import React, { useState, useRef } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import downArrow from "./images/arrow.svg";
import { NUMBER } from "../../../constants/app-constants";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { EVENT_DATA } from "../car-details/tracking";

const ClassifiedCdpCommentsFromDealer = ({commentsFromDealer = "", appointmentId = ""}) => {
    const [expanded, setExpanded] = useState(false);
    const textRef = useRef(null);
    const toggleExpand = () => {
        // Track "Read more" click when expanding
        if (!expanded) {
            trackDesktopCustomEventsAU(EVENT_DATA.DEALER_COMMENTS_READ_MORE_CLICKED, {
                ...EVENT_DATA.DEALER_COMMENTS_READ_MORE_CLICKED,
                eventLabel: appointmentId
            });
        }
        setExpanded(!expanded);
    };

    const getFormattedComment = () => {
        if (!commentsFromDealer) {
            return null;
        }
        return commentsFromDealer?.split("\n").map((line, index) => (
            <p key={index} size="150" className={styles.paragraph}>
                {line || "\u00A0"}
            </p>
        ));
    };
    if (!commentsFromDealer || !commentsFromDealer?.trim()?.length) {
        return null;
    }
    return (
        <div styleName={"styles.commentsFromDealerContainer"}>
            <p styleName={"styles.commentsFromDealerHeading"}>Comments from the dealer</p>
            <p
                ref={textRef}
                styleName={expanded ? "styles.commentsFromDealerExpanded" : "styles.commentsFromDealer"}
            >
                {getFormattedComment()}
            </p>
            {commentsFromDealer?.length > NUMBER.TWO_HUNDRED && (
                <p styleName={"styles.readMore"} onClick={toggleExpand}>
                    {expanded ? "Read less" : "Read more"}
                    <img
                        src={downArrow}
                        alt=""
                        style={{
                            transform: expanded ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.3s ease"
                        }}
                    />
                </p>
            )}
        </div>
    );
};

ClassifiedCdpCommentsFromDealer.propTypes = {
    commentsFromDealer: PropTypes.string.isRequired,
    appointmentId: PropTypes.string
};

export default ClassifiedCdpCommentsFromDealer;
